import { render, staticRenderFns } from "./Descartados.vue?vue&type=template&id=5941c6bf&"
import script from "./Descartados.vue?vue&type=script&lang=js&"
export * from "./Descartados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports